export default __webpack_public_path__ + "static/media/bx-barcode-reader.d8cfb421.svg";